module.exports = __webpack_public_path__ + "img/layer-unit.025e93d9.png";